// extracted by mini-css-extract-plugin
module.exports = {"section":"TH","eso":"UH","sectionOpen":"VH","estimatedDelivery":"WH"};